import { Component, OnInit } from '@angular/core'
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms'
import { validateAllFormFields } from '../../../../formUtils'
import { CareFinityValidators } from '../../../validators/CareFinityValidators'
import { UserService } from '../../../../api/services'
import { MessageService } from 'primeng/api'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
@Component({
  selector: 'app-reset-user-password',
  templateUrl: './reset-user-password.component.html',
  styleUrls: ['./reset-user-password.component.css'],
})
export class ResetUserPasswordComponent implements OnInit {
  changePassword: UntypedFormGroup
  errorValidationSummary: SafeHtml
  ShowErrorSummary: boolean = false
  constructor(
    private fb: UntypedFormBuilder,
    private userService: UserService,
    private messageService: MessageService,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    this.changePassword = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required],
      confirmPassword: ['', Validators.required],
    })

    this.changePassword.setValidators(
      CareFinityValidators.Match('newPassword', 'confirmPassword'),
    )
  }

  resetPassword(): void {
    this.errorValidationSummary = ''
    validateAllFormFields(this.changePassword)
    if (this.changePassword.invalid) {
      return
    }
    this.userService
      .userChangePassword({
        practiceId: localStorage.getItem('PracticeId'),
        userID: Number(localStorage.getItem('loggedInUserId')),
        currentPassword: this.changePassword.get('currentPassword').value,
        newPassword: this.changePassword.get('newPassword').value,
      })
      .subscribe((X) => {
        debugger

        if (X.status.toLowerCase().indexOf('error') > -1) {
          this.ShowErrorSummary = true
          this.errorValidationSummary = this.sanitizer.bypassSecurityTrustHtml(
            X.message,
          )

          this.messageService.add({
            key: 'alertToast',
            severity: 'error',
            summary: 'ERROR',
            detail: X.message,
            life: 5000,
          })
        } else if (X.status.toLowerCase().indexOf('ok') > -1) {
          this.ShowErrorSummary = false

          this.messageService.add({
            key: 'alertToast',
            severity: 'success',
            summary: 'Confirmation',
            detail: X.message,
            life: 5000,
          })

          this.changePassword.reset()

          return
        }
      })
  }
}
